import { render, staticRenderFns } from "./time-widget.vue?vue&type=template&id=2f0cf21d&scoped=true&"
import script from "./time-widget.vue?vue&type=script&lang=js&"
export * from "./time-widget.vue?vue&type=script&lang=js&"
import style0 from "./time-widget.vue?vue&type=style&index=0&id=2f0cf21d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0cf21d",
  null
  
)

export default component.exports